// Helper function to safely access environment variables
function getEnvVar(key: string): string | undefined {
  // Check if we're in a browser environment with Vite
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    // Handle Vite's environment variable naming convention
    return import.meta.env[key];
  }

  // For Node.js process.env
  if (typeof process !== 'undefined' && process.env) {
    return process.env[key];
  }

  return undefined;
}

function loadEnv() {
  return {
    // R2 Configuration
    R2_ACCESS_KEY: getEnvVar('R2_ACCESS_KEY'),
    R2_SECRET_KEY: getEnvVar('R2_SECRET_KEY'),
    R2_ENDPOINT: getEnvVar('R2_ENDPOINT') || 'https://65a02bf6b5eb66d5880ebecb3e152d52.r2.cloudflarestorage.com',

    // API URLs
    VITE_PUBLIC_API_URL: getEnvVar('VITE_PUBLIC_API_URL'),
    VITE_APP_URL: getEnvVar('VITE_APP_URL'),
    // Firebase Configuration
    VITE_FIREBASE_API_KEY: getEnvVar('VITE_FIREBASE_API_KEY'),
    VITE_FIREBASE_AUTH_DOMAIN: getEnvVar('VITE_FIREBASE_AUTH_DOMAIN'),
    VITE_FIREBASE_PROJECT_ID: getEnvVar('VITE_FIREBASE_PROJECT_ID'),
    VITE_FIREBASE_STORAGE_BUCKET: getEnvVar('VITE_FIREBASE_STORAGE_BUCKET'),
    VITE_FIREBASE_MESSAGING_SENDER_ID: getEnvVar('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    VITE_FIREBASE_DATABASE_URL: getEnvVar('VITE_FIREBASE_DATABASE_URL'),
    VITE_FIREBASE_APP_ID: getEnvVar('VITE_FIREBASE_APP_ID'),
    VITE_VAPID_KEY: getEnvVar('VITE_VAPID_KEY'),
    VITE_SENTRY_DSN: getEnvVar('VITE_SENTRY_DSN'),
    // YouTube API
    YOUTUBE_API_KEY: getEnvVar('YOUTUBE_API_KEY'),
    // Mapbox
    MAPBOX_TOKEN: getEnvVar('VITE_MAPBOX_TOKEN'),
    // Supabase
    VITE_SUPABASE_URL: getEnvVar('VITE_SUPABASE_URL'),
    VITE_SUPABASE_ANON_KEY: getEnvVar('VITE_SUPABASE_ANON_KEY'),
  };
}

// Create a singleton instance
const env = loadEnv();
export default env;
